'use client';

import React from 'react';
import Link from 'next/link';
import { Lock } from 'lucide-react';
import LandingNav from '@/app/public-landing-page/components/LandingNav';
import LandingFooter from '@/app/public-landing-page/components/LandingFooter';

export function PublicCertificateRestricted({
  title,
  message,
  showRequestAccess = false,
}: {
  title: string;
  message: string;
  showRequestAccess?: boolean;
}) {
  return (
    <div className="public-page public-family-verify min-h-screen">
      <LandingNav />
      <main className="mx-auto flex max-w-lg flex-col items-center px-6 py-24 text-center">
        <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full border border-slate-200 bg-slate-50">
          <Lock size={24} className="text-slate-400" />
        </div>
        <h1 className="mb-2 text-xl font-bold text-[#002B7F]">{title}</h1>
        <p className="mb-8 text-sm leading-relaxed text-slate-600">{message}</p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link href="/login" className="public-button public-button-trust">
            Sign in
          </Link>
          {showRequestAccess && (
            <Link
              href="/login?intent=request-access"
              className="public-button public-button-premium"
            >
              Request access
            </Link>
          )}
          <Link href="/" className="public-button public-button-secondary">
            Return home
          </Link>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
}

export function PublicCertificatePrivate() {
  return (
    <PublicCertificateRestricted
      title="Certificate is private"
      message="This certificate is not publicly shared. The owner or issuing institution must enable access before it can be viewed."
      showRequestAccess
    />
  );
}

export function PublicCertificateNotFound() {
  return (
    <PublicCertificateRestricted
      title="Record not found"
      message="This link may be invalid or the record may have been removed."
    />
  );
}
